import React from 'react'

const AssignmentVolumetryHome: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_555_29630)" />
    <g clipPath="url(#clip0_555_29630)">
      <path
        d="M35.4003 32.5705C35.5386 32.8807 35.7004 33.1798 35.8843 33.4652L50.367 30.5839C49.7766 28.5095 48.7717 26.5764 47.413 24.9015C46.0543 23.2265 44.37 21.8446 42.462 20.8391C40.5539 19.8337 38.4618 19.2257 36.3121 19.0519C34.1624 18.8781 31.9997 19.142 29.955 19.8279L35.4003 32.5705Z"
        fill="white"
      />
      <path
        d="M35.8413 37.3228C34.5784 36.3565 33.583 35.0839 32.9493 33.6254L27.5026 20.8748C25.4367 21.9661 23.6351 23.497 22.2246 25.3596C20.8141 27.2223 19.8289 29.3714 19.3385 31.6558C18.8482 33.9403 18.8644 36.3044 19.3862 38.5818C19.9079 40.8593 20.9225 42.9947 22.3585 44.8378C23.7945 46.6809 25.617 48.1868 27.6977 49.2497C29.7785 50.3125 32.0669 50.9063 34.4018 50.9894C36.7368 51.0725 39.0616 50.6428 41.2126 49.7306C43.3637 48.8184 45.2886 47.4458 46.852 45.7094L35.8413 37.3228Z"
        fill="white"
      />
      <path
        d="M38.1536 35.7321L48.4749 43.5987C50.1243 41.0342 51.001 38.0492 51.0002 35.0001C50.998 34.3981 50.9619 33.7967 50.8922 33.1987L38.1536 35.7321Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_555_29630"
        x1="35"
        y1="11"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E2EBD" />
        <stop offset="1" stopColor="#4A148C" />
      </linearGradient>
      <clipPath id="clip0_555_29630">
        <rect width="32" height="32" fill="white" transform="translate(19 19)" />
      </clipPath>
    </defs>
  </svg>
)

export default AssignmentVolumetryHome
